import { useCallback } from "react";
import {
  cloneEmptyWithIndication,
  cloneNormalWithIndication,
  type ExamWorksheetData,
  isWorksheetAllNormal,
} from "../../../global-providers/rxdb-provider/collections/epocus-exam-worksheets";

export const useAllNormal = ({
  currentData,
  onSetNormal,
  onClear,
}: {
  currentData: ExamWorksheetData | null;
  onSetNormal: (normalData: ExamWorksheetData) => void;
  onClear: (emptyData: ExamWorksheetData) => void;
}) => {
  // Derived, not stored: the toggle reflects the live worksheet state, so
  // editing any exception away from normal turns it off automatically.
  const isAllNormal = currentData ? isWorksheetAllNormal(currentData) : false;

  const toggle = useCallback(() => {
    if (!currentData) return;
    if (isAllNormal) {
      // Only reachable while the worksheet is exactly normal (no manual
      // exceptions), so clearing to empty discards no clinical edits.
      onClear(cloneEmptyWithIndication(currentData));
    } else {
      // "All Normal" fills findings with normal defaults but preserves the
      // clinical indication and any free-text notes — neither is a finding.
      onSetNormal({
        ...cloneNormalWithIndication(currentData),
        notes: currentData.notes,
      });
    }
  }, [isAllNormal, currentData, onSetNormal, onClear]);

  return { isAllNormal, toggle };
};
